var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 5,
    fill: "#128B9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4194 9.46242C20.5047 9.37538 20.6065 9.30623 20.7188 9.25902C20.8312 9.21181 20.9519 9.1875 21.0737 9.1875C21.1956 9.1875 21.3163 9.21181 21.4286 9.25902C21.541 9.30623 21.6428 9.37538 21.7281 9.46242C22.0856 9.82367 22.0906 10.4074 21.7406 10.7749L14.3494 19.5124C14.2654 19.6046 14.1636 19.6786 14.0501 19.7301C13.9366 19.7815 13.8137 19.8093 13.6891 19.8116C13.5645 19.8139 13.4407 19.7908 13.3254 19.7437C13.21 19.6965 13.1054 19.6264 13.0181 19.5374L8.52061 14.9799C8.34716 14.803 8.25 14.5652 8.25 14.3174C8.25 14.0697 8.34716 13.8318 8.52061 13.6549C8.60592 13.5679 8.70774 13.4987 8.8201 13.4515C8.93246 13.4043 9.05311 13.38 9.17499 13.38C9.29687 13.38 9.41752 13.4043 9.52988 13.4515C9.64224 13.4987 9.74406 13.5679 9.82936 13.6549L13.6444 17.5212L20.3944 9.48992L20.4194 9.46242Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCheck);
export default __webpack_public_path__ + "static/media/dashboard-check.a33bcf49179f344c2640cfd8aeefc44d.svg";
export { ForwardRef as ReactComponent };